
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import { prepareQueryParams } from "@/helpers/SearchHelper";
import { sourceValueToName, categoryRouteTranslator } from "@/helpers/APIHelper";
import { trackEvent, EventType } from "@/helpers/AmplitudeHelper";

export default defineComponent({
  name: "SearchMobile",
  methods: {
    ...mapActions([
      'saveTemplate', 
      'toggleMobileFiltersModal', 
      'searchTenders', 
      'setQuery', 
      'setQueryFavourites',
      'setQueryTemplates',
      'setQueryCompany',
      'getNewTenders', 
      'getFavourites', 
      'getTemplates',
      'toggleAuthModal',
      'deleteTemplate',
    ]),
    async handleMobileSearch() {
      const mobileSearchInput = this.$refs.mobileSearch as HTMLInputElement | null;
      if (mobileSearchInput) {
        mobileSearchInput.blur();
      }
      switch (this.currentRoute) {
        case 'tenderSerp':
          this.searchTender();
          break;
        case 'favourites':
          this.searchFavourites();
          break;
        case 'templates':
          this.searchTemplates();
          break;
        case 'company':
          this.searchCompany();
          break;
        case 'companies':
          this.searchCompanies();
          break;
        default:
          break;
      }
    },
    async handleStarClick() {
      if (!this.templateExists) {
        await this.saveTemplate({ query: this.mobileQuery, filters: this.filters, notificationMessage: this.$t('notifications.add_template') })
      } else {
        await this.deleteTemplate({ templateId: this.templateExists, notificationMessage: this.$t('notifications.delete_template') } )
      }
    },
    async searchTender() {
      const queryParams = prepareQueryParams(1, this.mobileQuery, this.filters, this.$store.getters.contentFilter)
      
      this.$router.push({
        name: "tenderSerp",
        query: queryParams,
      })
    },
    async searchCompany() {
      const queryParams = prepareQueryParams(1, this.mobileQuery, this.filters, this.$store.getters.contentFilter)
      
      this.$router.push({
        name: "company",
        query: queryParams,
      })
    },
    async searchFavourites() {
      const queryParams = prepareQueryParams(1, this.mobileQuery, this.filters, this.$store.getters.contentFilter)
      this.$router.push({
        name: "favourites",
        query: queryParams,
      })
    },
    async searchTemplates() {
      this.$router.push({
        name: "templates",
        query: {
          page: 1,
          ...(this.mobileQuery !== '' ? { q: this.mobileQuery } : {}),
        },
      })
    },
    async searchCompanies() {
      const queryParams: Record<string, string | number> = {
        page: 1,
        ...(this.mobileQuery === '' ? {} : { q: this.mobileQuery }) 
      };
      this.$router.push({
        name: "companies",
        query: queryParams
      })
      trackEvent(EventType.companies_search, this.mobileQuery !== '' ? { request_text: this.mobileQuery } : undefined)
    }
  },
  computed: {
    ...mapGetters(['filters', 'page', 'isAuthenticated', 'templateExists', 'company']),
    currentRoute () {
      return this.$route.name
    },
    mobileTitle() {
      switch (this.currentRoute) {
        case 'tenderSerp':
          return this.$t('mobile.title_search');
        case 'favourites':
          return this.$t('mobile.title_favourites');
        case 'templates':
          return this.$t('mobile.title_templates');
        case 'sourceSerp':
          return this.$t('serp_header.source_header', { source: sourceValueToName[this.$route.params.source as keyof typeof sourceValueToName] });
        case 'typeSerp':
          return this.$t('serp_header.type_header', { type: this.$t(`serp_header.type_${this.$route.params.type}`) });
        case 'regionSerp':
          return this.$t('serp_header.region_header', { region: this.$t(`serp_header.region_${this.$route.params.region}`) });
        case 'categorySerp':
          return this.$store.getters.categoryDict[categoryRouteTranslator[this.$route.params.category as keyof typeof categoryRouteTranslator]];
        case 'companies':
          return this.$t("collections.header_companies")
        default:
          return '';
      }
    },
    mobilePlaceholder() {
      switch (this.currentRoute) {
        case 'tenderSerp':
          return this.$t('mobile.search_placeholder');
        case 'favourites':
          return this.$t('favourites_page.search_placeholder');
        case 'templates':
          return this.$t('templates_page.search_placeholder');
        case 'company':
          return this.$t('company_page.search_placeholder');
        case 'companies':
          return this.$t('collections.search_placeholder');
        default:
          return '';
      }
    },
    mobileQuery: {
      get() {
        switch (this.currentRoute) {
          case 'tenderSerp':
            return this.$store.getters.query;
          case 'favourites':
            return this.$store.getters.queryFavourites;
          case 'templates':
            return this.$store.getters.queryTemplates;
          case 'company':
            return this.$store.getters.queryCompany;
          case 'companies':
            return this.$store.getters.queryCompany;
          default:
            return ''
        }
      },
      set(value: string) {
        switch (this.currentRoute) {
          case 'tenderSerp':
            this.$store.dispatch('setQuery', { query: value });
            break;
          case 'favourites':
            this.$store.dispatch('setQueryFavourites', { query: value });
            break;
          case 'templates':
            this.$store.dispatch('setQueryTemplates', { query: value });
            break;
          case 'company':
            this.$store.dispatch('setQueryCompany', { query: value });
            break;
          case 'companies':
            this.$store.dispatch('setQueryCompany', { query: value });
            break;
          default:
            break;
        }
      }
    }
  },
});
